import React from 'react';
import { Tooltip, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Track from '../../helpers/Analytics';

const useStyles = makeStyles(theme => ({
  goBackToMetrics: {
    paddingTop: 7
  },
  link: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '13px'
  },
  svg: {
    marginBottom: -5
  }
}));

const ReturnToMetricsLink = () => {
  const classes = useStyles();
  return (
    <Tooltip title='Return to Pick Metrics page'>
      <div className={classes.goBackToMetrics}>
        <Link className={classes.link} component={RouterLink} to='/' onClick={() => Track('ReturnToMetrics-Click')}>
          <svg className={classes.svg} xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'>
            <path d='M11.56 5.56L10.5 4.5 6 9l4.5 4.5 1.06-1.06L8.12 9z' />
          </svg>
          {`Return to Metrics`}
        </Link>
      </div>
    </Tooltip>
  );
};

export default ReturnToMetricsLink;
